import image1 from '@/assets/images/news/detail/20200421/1.jpg';

export default {
  id: '20200421', //  模块 id
  title: '雄关漫道真如铁 而今迈步从头越', // 标题
  origin: '', // 新闻来源
  editor: '', // 编辑者
  content: [
    // {
    //   type: 0, // 数据类型 0-普通文本 1-图片 2-空行
    //   text: '2020年4月21日，这个必将载入叮咚史册的日子：北京我们来了！', // 文本内容
    //   isIndent: false, // 是否首行缩进 true-首行缩进 false-不缩进
    // },
    // {
    //   type: 1,
    //   title: '图片下方标题', // 图片下方标题
    //   src: [
    //     'kkk' // 图片地址
    //   ],
    // },
    // {
    //   type: 2, // 数据类型 0-普通文本 1-图片 2-空行
    // },

    {
      type: 0,
      text: 'sss',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image1],
    },
  ],
};
